module.exports = __webpack_public_path__ + "assets/img/more-btn-0d7770c4.png";